import Vue from 'vue'
import Vuex from 'vuex'
import locale from './modules/locale'
import esg from './modules/esg'
import entity from './modules/entity'
import limits from './modules/limits'

// 挂载Vuex
Vue.use(Vuex)

// 创建VueX对象
const store = new Vuex.Store({
  modules: {
    locale,
    esg,
    entity,
    limits
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js